import { createFileRoute } from "@tanstack/react-router";
import SeoLocalCiudad, { citiesData, buildCityFaqs } from "@/pages/servicios/SeoLocalCiudad";
import { getCiudadContenido } from "@/data/seo-local-ciudades";


export const Route = createFileRoute("/servicios/seo-local/$ciudad")({
  component: SeoLocalCiudad,
  head: ({ params }) => {
    const ciudadLower = params.ciudad?.toLowerCase();
    const cityData = ciudadLower ? citiesData[ciudadLower] : null;

    if (!cityData) {
      return {
        meta: [
          { title: "Ciudad no disponible | SEOEVOLUTION" },
          { name: "robots", content: "noindex" },
        ],
      };
    }

    const title = `SEO local en ${cityData.name} y Google Maps | SEOEVOLUTION`;
    const description = `SEO local para negocios con área de servicio en ${cityData.name}: ficha de Google Business Profile, contenido y señales locales. Propuesta personalizada y mínimo de 3 meses.`;
    const canonicalUrl = `https://agenciaseoevolution.com/servicios/seo-local/${ciudadLower}`;

    const schema = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": `SEOEVOLUTION - SEO Local ${cityData.name}`,
      "description": description,
      "areaServed": {
        "@type": ciudadLower === "asturias" ? "AdministrativeArea" : "City",
        "name": cityData.name,
        "containedIn": {
          "@type": "AdministrativeArea",
          "name": cityData.province
        }
      },
      "url": canonicalUrl,
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Servicios SEO Local",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Optimización Google Business Profile",
              "description": "Optimización completa de tu ficha en Google Maps"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "SEO Local con IA",
              "description": "Estrategias de posicionamiento local impulsadas por inteligencia artificial"
            }
          }
        ]
      }
    };

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: buildCityFaqs(cityData.name, getCiudadContenido(ciudadLower ?? "")).map((f) => ({
        "@type": "Question",
        name: f.question,
        acceptedAnswer: { "@type": "Answer", text: f.answer },
      })),
    };

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Inicio", item: "https://agenciaseoevolution.com" },
        {
          "@type": "ListItem",
          position: 2,
          name: "SEO Local con IA",
          item: "https://agenciaseoevolution.com/servicios/seo-local-ia",
        },
        { "@type": "ListItem", position: 3, name: cityData.name, item: canonicalUrl },
      ],
    };

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { name: "keywords", content: cityData.keywords.join(', ') },
        { property: "og:type", content: "website" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: canonicalUrl },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [
        { rel: "canonical", href: canonicalUrl },
      ],
      scripts: [
        { type: "application/ld+json", children: JSON.stringify(schema) },
        { type: "application/ld+json", children: JSON.stringify(faqSchema) },
        { type: "application/ld+json", children: JSON.stringify(breadcrumbSchema) },
      ],
    };
  },
});

